


















import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';

@Component({
  name: 'LoadingPanel',
})
export default class LoadingPanel extends Vue {
  @Prop({type: Boolean, default: false}) readonly loading!: boolean;
}
